<template>
  <div class="d-bank _purchase _first _header">
    <div class="d-bank__item _item1">
      <img class="d-bank__logo" :src="item.logo">
    </div>
    <div class="d-bank__item _program">
      {{ count }}
      <div class="d-bank__name">{{ item.bank }}</div>
    </div>
    <div  class="d-bank__item">
    </div>
    <div class="d-bank__item">
    </div>
    <div class="d-bank__item">
    </div>
    <div class="d-bank__item">
    </div>
    <div class="d-bank__item _item7">
        <button class="d-button _dark" @click="$emit('hideBank')">
          <span>Скрыть</span>
        </button>
    </div>
    <button class="d-bank__button" @click="$emit('hideBank')"/>
  </div>
</template>

<script>
export default {
  name: 'DMortgageBankHeader',
  props: {
    item: Object,
    count: String,
  },
};
</script>
